export { Tabs } from './Tabs';
export { AutoTabs } from './AutoTabs';
export type { TabsSize, TabsItemType, OnChooseItem } from './types';
